import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Container, Grid2, InputAdornment, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import checkIcon from "../assets/images/check-icon.png";
import titleIcon from "../assets/images/title-icon.png";
import VendorSelectionCard from "../components/common/VendorSelectionCard";
import { validateForm } from "../utils//validation/enquire-vendors-validation";
import productService from "../services/productService";
import vendorService from "../services/vendorService";
import Breadcrumbs from "../components/common/Breadcrumb";
import { useNavigate } from "react-router-dom";
import VendorSelectionCardSkeleton from "../components/common/VendorCardSkeleton";
const EnquireVendors = () => {
  // const [checked, setChecked] = useState(false);
  const location = useLocation();
  const { productName, vendorName } = location.state || {};
  const [isShowResult, setIsShowResult] = useState(false);
  const [vendors, setVendors] = useState([]);
  const [submitStatus, setSubmitStatus] = useState(false);
  const navigate = useNavigate();
  const handleToggle = (id) => {
    setVendors((prevVendors) =>
      prevVendors.map(
        (vendor) =>
          vendor.id === id
            ? { ...vendor, selected: true } // select clicked vendor
            : { ...vendor, selected: false } // unselect all others
      )
    );
  };

  const [formData, setFormData] = useState({
    restaurantId: "",
    restaurantName: "",
    emailAddress: "",
    cityName: "",
    contactNo: "",
    requirement: "",
    vendors: [],
  });
  const [errors, setErrors] = useState({});
  const { productUrl } = useParams();
  const id = productUrl?.split("-").pop();

  const handlePhoneChange = (e) => {
    const value = e.target.value;
    // Allow only digits and max 10
    if (/^\d{0,10}$/.test(value)) {
      setFormData({ ...formData, contactNo: value });
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    const selectedVendors = vendors.filter((vendor) => vendor.selected);

    // Sync them into formData for validation
    const updatedFormData = {
      ...formData,
      vendors: selectedVendors,
    };
    const validationErrors = validateForm(updatedFormData);

    if (Object.keys(validationErrors).length === 0) {
      setSubmitStatus(!submitStatus);
      const selectedVendorNames = vendors
        .filter((vendor) => vendor.selected)
        .map((vendor) => vendor.name)
        .join(", ");

      const payload = {
        restaurantId: formData.restaurantId,
        restaurantName: formData.restaurantName,
        emailAddress: formData.emailAddress,
        cityName: formData.cityName,
        contactNo: `+91${formData.contactNo}`,
        productName: productName || "",
        vendors: selectedVendorNames,
        DetailRequirements: formData.requirement,
      };
      try {
        await productService.submitEnquiry(payload);
        setIsShowResult(true);
        setSubmitStatus(!submitStatus);
      } catch (err) {
        console.error("Error submitting enquiry:", err);
        // optionally show error message to user
      }
    } else {
      setErrors(validationErrors);
    }
  };
  useEffect(() => {
    const fetchVendors = async () => {
      try {
        const data = await vendorService.getVendors();
        const transformed = data.map((vendor) => ({
          id: vendor.id,
          name: vendor.vendorName,
          location: vendor.vLocation,
          image: vendor.imageUrl,
          price: "₹17.23",
          selected:
            vendor.id?.toString() === id || vendorName === vendor.vendorName,
        }));
        setVendors(transformed);
      } catch (err) {
        console.error("Error fetching vendors:", err);
      }
    };

    fetchVendors();
  }, [vendorName, id]); // include vendorName in deps just in case

  return (
    <>
      {!isShowResult ? (
        <section className="inner-baner enquire-vendor-box">
          <Container>
            <div className="breadcrumb">
              <ul>
                <Breadcrumbs />
              </ul>
            </div>
            <Grid2 container spacing={2}>
              <Grid2 size={{ lg: 3, md: 12 }}>
                <div className="back-arrow text-white">
                  <div
                    className="back-arrow text-white"
                    onClick={() => navigate(-1)}
                    style={{ cursor: "pointer" }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M10.0164 2.86402C10.5046 2.41035 11.2681 2.43834 11.7218 2.92652C12.1754 3.41471 12.1475 4.17823 11.6593 4.63189L5.9091 9.97545C5.56441 10.2958 5.27721 10.5634 5.03763 10.795L21.7309 10.795C22.3974 10.795 22.9376 11.3353 22.9376 12.0017C22.9376 12.6681 22.3974 13.2084 21.7309 13.2084L4.96299 13.2084C5.21692 13.4563 5.52784 13.7462 5.90908 14.1005L11.5886 19.3785C12.0768 19.8322 12.1048 20.5957 11.6511 21.0839C11.1974 21.5721 10.4339 21.6 9.94575 21.1464L4.20777 15.814C3.51539 15.1707 2.90681 14.6052 2.48249 14.0857C2.02422 13.5246 1.65356 12.8684 1.65356 12.0379C1.65357 11.2075 2.02424 10.5513 2.48251 9.99021C2.90682 9.47068 3.51538 8.90523 4.20774 8.26193L10.0164 2.86402Z"
                        fill="#02060C"
                        fillOpacity="0.75"
                      />
                    </svg>
                  </div>
                </div>
                <div className="section-title md-mb-0 mobile-section-title">
                  <h2>Send an enquiry for {productName}</h2>
                  <div className="mobile-enq-image">
                    <img src={titleIcon} alt="" />
                  </div>
                </div>
              </Grid2>
              <Grid2 size={{ lg: 9, md: 12 }}>
                <div className="form-card">
                  <h3>
                    Restaurant Details<sup>*</sup>
                  </h3>
                  <Grid2
                    container
                    spacing={2}
                    sx={{
                      justifyContent: "space-between",
                    }}
                  >
                    <Grid2 size={{ lg: 5, md: 5, xs: 12 }}>
                      <TextField
                        id="outlined-basic"
                        label="Swiggy Restaurant ID"
                        name="restaurantId"
                        value={formData.restaurantId}
                        onChange={handleChange}
                        error={!!errors.restaurantId}
                        helperText={errors.restaurantId}
                        variant="outlined"
                        InputLabelProps={{
                          style: { color: "inherit" },
                        }}
                      />
                    </Grid2>
                    <Grid2 size={{ lg: 5, md: 5, xs: 12 }}>
                      <TextField
                        id="outlined-basic"
                        label="Restaurant Name"
                        value={formData.restaurantName}
                        onChange={handleChange}
                        error={!!errors.restaurantName}
                        helperText={errors.restaurantName}
                        variant="outlined"
                        name="restaurantName"
                        InputLabelProps={{
                          style: { color: "inherit" },
                        }}
                      />
                    </Grid2>
                    <Grid2 size={{ lg: 5, md: 5, xs: 12 }}>
                      <TextField
                        id="outlined-basic"
                        label="Email address"
                        variant="outlined"
                        name="emailAddress"
                        value={formData.emailAddress}
                        onChange={handleChange}
                        error={!!errors.emailAddress}
                        helperText={errors.emailAddress}
                        InputLabelProps={{
                          style: { color: "inherit" },
                        }}
                      />
                    </Grid2>
                    <Grid2 size={{ lg: 5, md: 5, xs: 12 }}>
                      <TextField
                        label="Phone Number"
                        value={formData.contactNo}
                        inputProps={{ maxLength: 10 }}
                        helperText={errors.contactNo}
                        onChange={(e) => handlePhoneChange(e)}
                        error={!!errors.contactNo}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <div className="number-wrapper">
                                <span className="number-start-indian">+91</span>
                                <div className="number-strip" />
                              </div>
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Grid2>
                    <Grid2 size={{ lg: 5, md: 5, xs: 12 }}>
                      <TextField
                        id="outlined-basic"
                        label="City Name"
                        value={formData.cityName}
                        onChange={handleChange}
                        error={!!errors.cityName}
                        helperText={errors.cityName}
                        variant="outlined"
                        name="cityName"
                        InputLabelProps={{
                          style: { color: "inherit" },
                        }}
                      />
                    </Grid2>
                  </Grid2>
                </div>
                <div className="form-card">
                  <h3 className="xs-mb-0">
                    Select Vendors<sup>*</sup>
                  </h3>
                  <p className="mob-show mob-subtitle">
                    We’ll send your enquiry to the vendors you select
                  </p>
                  <Grid2 container spacing={2} className="select-vendor-wrap">
                    {vendors.length === 0
                      ? Array.from({ length: 3 }).map((_, index) => (
                          <Grid2
                            key={index}
                            size={{ sm: 6, md: 4, lg: 4, xs: 12 }}
                          >
                            <VendorSelectionCardSkeleton />
                          </Grid2>
                        ))
                      : vendors.map((vendor) => (
                          <Grid2
                            key={vendor.id}
                            size={{ sm: 6, md: 4, lg: 4, xs: 12 }}
                          >
                            <VendorSelectionCard
                              vendor={vendor}
                              onToggle={handleToggle}
                            />
                          </Grid2>
                        ))}
                    <Grid2 size={12} className="mob-none">
                      <div className="note">
                        <FontAwesomeIcon icon={faExclamationCircle} />
                        We’ll send your enquiry to the vendors you select
                      </div>
                    </Grid2>
                  </Grid2>
                </div>
                <div className="form-card">
                  <h3>Describe Your Requirements</h3>
                  <Grid2 container spacing={2}>
                    <Grid2 size={12}>
                      <TextField
                        id="requirement"
                        variant="outlined"
                        multiline
                        minRows={5}
                        maxRows={10}
                        placeholder="Custom requirements like logo branding on the packaging, Multiple products enquiry etc..."
                        name="requirement"
                        value={formData.requirement}
                        onChange={handleChange}
                      />
                    </Grid2>
                  </Grid2>
                </div>
                <div className="enquiry-submit-btn">
                  <button
                    className={`btn btn-orange ${
                      submitStatus ? "disabled" : ""
                    }`}
                    type="button"
                    onClick={handleSubmit}
                    disabled={submitStatus}
                  >
                    {submitStatus ? "Sending..." : "Send an enquiry"}
                  </button>
                </div>
              </Grid2>
            </Grid2>
          </Container>
        </section>
      ) : (
        <section className="enquiry-result-status">
          <Container>
            <Grid2 container spacing={2}>
              <Grid2 size={12}>
                <div className="success-msg">
                  <img src={checkIcon} alt="" />
                  <h2>Your Enquiry is send successfully!</h2>
                  <p>
                    we have sent you confirmation email and SMS. Vendor will
                    reach out to you shortly.
                  </p>
                  <Link to={"/"} className="btn btn-orange" type="button">
                    Continue Browsing
                  </Link>
                </div>
              </Grid2>
            </Grid2>
          </Container>
        </section>
      )}
    </>
  );
};

export default EnquireVendors;
